import { GOOGLE_RECAPTCHA_SITE_KEY } from '@/constants/env';
import { useOTP } from '@/use/otp';
import { useSegment } from '@/use/segment';
import { useSession } from '@/use/session';
import { useRules } from '@/utils/rules';
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import _ from 'lodash';
import { load } from 'recaptcha-v3';
import { useSSO } from '@/use/sso';
import { ERROR, HELP, ALERT } from '@/constants/icons';
import { useToasts } from '@/use/toasts';
export default defineComponent({
  setup: () => {
    const passwordRef = ref(null);
    const confirmPasswordRef = ref(null);
    const updatePasswordModelRef = ref(null);
    const otpRef = ref(null);
    const {
      addToast
    } = useToasts();
    const inputData = ref({
      inputType: '',
      inputValue: ''
    });
    const recaptchaToken = ref('');
    const recaptcha = ref();
    const reCAPTCHASiteKey = ref(GOOGLE_RECAPTCHA_SITE_KEY);
    const password = ref('');
    const confirmPassword = ref('');
    const validOtp = ref(false);
    const otpValue = ref(null);
    const errorMessages = ref(null);
    const {
      resetTimer,
      timerCount,
      timerEnable,
      sendAuthenticationCode
    } = useOTP();
    const {
      resetPassword,
      login
    } = useSession();
    const {
      trackEvent
    } = useSegment();
    const {
      passwordRules,
      presenceRule
    } = useRules();
    const {
      showLoader
    } = useSSO();
    const confirmPasswordRules = [v => !!v || 'Confirm Password is required', v => !(v !== password.value) || "Doesn't match password"];
    onMounted(async () => {
      recaptcha.value = await load(reCAPTCHASiteKey.value);
    });
    onUnmounted(async () => {
      await recaptcha.value.hideBadge();
    });
    const matchingPasswordRules = [...presenceRule, val => _.isEqual(val, password.value) || 'Passwords do not match'];
    const resetValues = () => {
      var _otpRef$value;
      password.value = '';
      confirmPassword.value = '';
      validOtp.value = false;
      otpValue.value = null;
      errorMessages.value = null;
      otpRef === null || otpRef === void 0 ? void 0 : (_otpRef$value = otpRef.value) === null || _otpRef$value === void 0 ? void 0 : _otpRef$value.resetOtp();
      resetTimer();
    };
    const show = () => {
      updatePasswordModelRef.value.show();
    };
    const close = () => {
      updatePasswordModelRef.value.close();
    };
    const validateOtp = value => {
      otpValue.value = value;
    };
    const onChangeOtp = value => {
      validOtp.value = value.length === 6;
    };
    const validateUserObj = computed(() => {
      var _passwordRef$value, _confirmPasswordRef$v;
      return ((_passwordRef$value = passwordRef.value) === null || _passwordRef$value === void 0 ? void 0 : _passwordRef$value.validate()) && ((_confirmPasswordRef$v = confirmPasswordRef.value) === null || _confirmPasswordRef$v === void 0 ? void 0 : _confirmPasswordRef$v.validate()) && validOtp.value && password.value === confirmPassword.value;
    });
    const resendOTP = async () => {
      var _otpRef$value2, _inputData$value;
      otpRef === null || otpRef === void 0 ? void 0 : (_otpRef$value2 = otpRef.value) === null || _otpRef$value2 === void 0 ? void 0 : _otpRef$value2.resetOtp();
      recaptchaToken.value = await recaptcha.value.execute('send_otp');
      if (((_inputData$value = inputData.value) === null || _inputData$value === void 0 ? void 0 : _inputData$value.inputValue) !== '') {
        await sendAuthenticationCode(recaptchaToken.value, inputData.value, true, 'reset_password');
        validOtp.value = false;
        otpValue.value = null;
        errorMessages.value = null;
      }
    };
    const keyupEnter = keypressType => {
      if (keypressType === 'updatePassword') {
        if (validateUserObj.value) {
          updatePassword();
        }
      }
    };
    const updatePassword = async () => {
      recaptchaToken.value = await recaptcha.value.execute('update_password');
      showLoader(true);
      let data;
      if (password.value || confirmPassword.value) {
        var _inputData$value2, _inputData$value3;
        const user = {
          newPassword: password.value,
          confirmNewPassword: confirmPassword.value,
          mode: ((_inputData$value2 = inputData.value) === null || _inputData$value2 === void 0 ? void 0 : _inputData$value2.inputType) === 'email' ? 'email' : 'phone_number',
          otpPin: otpValue.value,
          value: (_inputData$value3 = inputData.value) === null || _inputData$value3 === void 0 ? void 0 : _inputData$value3.inputValue
        };
        data = await resetPassword(user, recaptchaToken.value).then(r => r);
        if (data && data.data && data.data.error) {
          addToast({
            color: 'error',
            prependIcon: ERROR,
            message: data.data.error
          });
          errorMessages.value = data.data.error;
        }
        if (data && data.status === 'ok') {
          var _inputData$value4;
          const user = {
            login: (_inputData$value4 = inputData.value) === null || _inputData$value4 === void 0 ? void 0 : _inputData$value4.inputValue,
            password: confirmPassword.value,
            remember: false
          };
          trackEvent('login', {
            submitMethod: 'update password'
          });
          close();
          await login(user);
        }
      }
      showLoader(false);
    };
    return {
      updatePasswordModelRef,
      show,
      close,
      inputData,
      resetValues,
      updatePassword,
      passwordRules,
      confirmPasswordRules,
      password,
      confirmPassword,
      keyupEnter,
      validateOtp,
      onChangeOtp,
      errorMessages,
      timerCount,
      timerEnable,
      validOtp,
      validateUserObj,
      resendOTP,
      passwordRef,
      confirmPasswordRef,
      matchingPasswordRules,
      HELP,
      ALERT,
      otpRef
    };
  }
});